module.exports = __webpack_public_path__ + "img/Jump Screenshoot (0-00-09-06)_21.c6ccdc51.jpg";